import PromoList from './components';
import connect from './containers/connect';

import compose from 'ramda/es/compose';

export default compose(connect)(PromoList);
